import React from 'react';

const NotFound = () => (
  <div className="container">
    <h1 className="container__header">404</h1>
    <p>Page not found...</p>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js